import { useStore } from "react-admin";
import { Autocomplete, TextField } from "@mui/material";

export const TIMEZONE_KEY = "user.timezone";
export const BrowserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const TimezoneSelect = () => {
  const allTimezones = Intl.supportedValuesOf("timeZone");
  allTimezones.unshift(BrowserTimezone);
  const tzWithLabels = allTimezones.map((tz) => ({
    id: tz,
    label: tz.replaceAll("_", " "),
  }));

  const [timezone, setTimezone] = useStore(TIMEZONE_KEY, BrowserTimezone);

  return (
    <Autocomplete
      value={timezone}
      onChange={(_, newValue) => {
        if (newValue.id) {
          setTimezone(newValue.id);
        }
      }}
      isOptionEqualToValue={(option, value) => option.id == value}
      options={tzWithLabels}
      renderInput={(params) => <TextField {...params} />}
      autoHighlight
      className="SystemTimezoneSelect"
    />
  );
};
